import React, { useState } from "react";
import Box from "@mui/material/Box";

import ImageModal from "../../../components/images/ImageModal";
import { sortImages } from "../../../utils/images";
import ImagesSlider from "./ImagesSlider";

export default function DisabledImagesOrders({ asset }) {
  const list = sortImages(asset?.images);
  const defaultIndex = list.findIndex(v => v.default);
  const [index, setIndex] = useState(defaultIndex === -1 ? 0 : defaultIndex);
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    if (list.length > 0) {
      setOpen(true);
    }
  };

  return (
    <>
      <Box
        position="relative"
        onClick={handleOpen}
        sx={{
          width: { xs: "90%", sm: "50%", md: "100%" },
          margin: "0 auto",
          cursor: list.length > 0 ? "pointer" : "default",
        }}
      >
        {list.length === 0 && <Box />}
        <ImagesSlider list={list} index={index} onChangeIndex={setIndex} />
      </Box>
      {open && list[index] && (
        <ImageModal
          open
          edit={false}
          displaySetAsDefault={false}
          images={list}
          asset={asset}
          selectedId={list[index].id}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  );
}

